module.exports = __webpack_public_path__ + "static/media/redCross.c4fa2dce.svg";